import React from "react";
import { motion } from "framer-motion";
import "./Project.css";
import NavBar from "../../NavBar";
import { ToastContainer } from "react-toastify";
// import butter6 from "../../SVGs/butterfly1.svg";
// import butter7 from "../../SVGs/butterfly2.svg";
import butter3 from "../../SVGs/butteranime1.gif"
import butter4 from "../../SVGs/butteranime2.gif"
import Hr from "../../SVGs/Hr";
import SectionHead from "../../Groups/SectionHead";
import bloodHub from "../../SVGs/bloodHub.svg";
import tape3 from "../../SVGs/tape-3.svg";
import reverbNation from "../../SVGs/reverbNation.svg";
import flappyBird from "../../SVGs/flapppyBird.png";
import quiz from "../../SVGs/Quiz.svg";
import diplomawale from "../../SVGs/diplomawale.svg";
import resumeBuilder from "../../SVGs/resumeBuilder.svg"
import { Link } from "react-router-dom";
import ui from "../../SVGs/ui.svg";
import ludo from "../../SVGs/ludo.svg";
import github from "../../SVGs/Github.svg"
import linkedin from "../../SVGs/Linkedin.svg"
import figma from "../../SVGs/figma.svg"
import canva from "../../SVGs/canva.svg"
import "../../Animation.css";
import "../../Home.css"

// Define unique animation variants for each image position with circular and slower movement
const animationVariants = {
  hidden: (direction) => ({
    opacity: 0,
    x: direction === "left" ? "-200vw" : "100vw",
    y: direction === "top" ? "-200vh" : "100vh",
    rotate: 5, // Start with no rotation
    scale: 0.8, // Slightly smaller size at start for effect
  }),
  visible: {
    opacity: 1,
    x: 0,
    y: 0,
    rotate: 720, // Full spin for “round, round” effect
    scale: 1, // Scale up to normal size
    transition: {
      type: "spring",
      stiffness: 50,
      damping: 10,
      duration: 2.5, // Slower duration for effect
      ease: "easeInOut", // Smooth easing for circular path
      delay: 0.3,
    },
  },
};

const Project = () => {
  return (
    <>
      <NavBar />
      <ToastContainer />
      <img src={butter3} alt="Butterfly 2" className="butterfly butterfly2" />
      <div className="container pt-md-5 pt-4">
          <img
            src={butter4}
            alt="Butterfly 2"
            className="butterfly butterfly1"
          />
        <div className="row text-center" id="home">
          <Hr />
          <SectionHead text={"PROJECTS"} img1={butter4} img2={butter4} />
          <Hr />
        </div>
      </div>
      <img src={butter3} alt="Butterfly 2" className="butterfly butterfly3" />
      <div className="project-container d-flex justify-content-center">
        <div className="grid-container">
          <motion.div
            className="projectSS position-relative"
            initial="hidden"
            animate="visible"
            custom="left"
            variants={animationVariants}
          >
            <img src={bloodHub} alt="bloodhub" className="bloodhub" />
            <img src={tape3} alt="" />
            <Link to={`/projects/1`}>
              <button className="project-button">View Project</button>
            </Link>
          </motion.div>
          <motion.div
            className="projectSS position-relative"
            initial="hidden"
            animate="visible"
            custom="right"
            variants={animationVariants}
          >
            <img
              src={reverbNation}
              alt="ReverbNation"
              className="reverbNation"
            />
            <img src={tape3} alt="" />
            <Link to={`/projects/2`}>
              <button className="project-button">View Project</button>
            </Link>
            <img
              src={butter4}
              alt="Butterfly 2"
              className="butterfly butterfly4"
            />
          </motion.div>
          <motion.div
            className="projectSS position-relative"
            initial="hidden"
            animate="visible"
            custom="top"
            variants={animationVariants}
          >
            <img src={flappyBird} alt="flappyBird" />
            <img src={tape3} alt="" />
            <Link to={`/projects/3`}>
              <button className="project-button">View Project</button>
            </Link>
          </motion.div>
          <motion.div
            className="projectSS position-relative"
            initial="hidden"
            animate="visible"
            custom="top"
            variants={animationVariants}
          >
            <img src={quiz} alt="flappyBird" />
            {/* <img src={tape3} alt="" /> */}
            <Link to={`/projects/4`}>
              <button className="project-button">View Project</button>
            </Link>
          </motion.div>
          <motion.div
            className="projectSS position-relative"
            initial="hidden"
            animate="visible"
            custom="top"
            variants={animationVariants}
          >
            <img src={diplomawale} alt="flappyBird" />
            {/* <img src={tape3} alt="" /> */}
            <Link to={`/projects/5`}>
              <button className="project-button">View Project</button>
            </Link>
          </motion.div>
          <motion.div
            className="projectSS position-relative"
            initial="hidden"
            animate="visible"
            custom="top"
            variants={animationVariants}
          >
            <img src={ui} alt="flappyBird" />
            <img src={tape3} alt="" />
            <Link to={`/projects/6`}>
              <button className="project-button">View Project</button>
            </Link>
          </motion.div>
          <motion.div
            className="projectSS position-relative"
            initial="hidden"
            animate="visible"
            custom="top"
            variants={animationVariants}
          >
            <img src={ludo} alt="flappyBird" />
            <img src={tape3} alt="" />
            <Link to={`/projects/7`}>
              <button className="project-button">View Project</button>
            </Link>
          </motion.div>
          <motion.div
            className="projectSS position-relative"
            initial="hidden"
            animate="visible"
            custom="top"
            variants={animationVariants}
          >
            <img src={resumeBuilder} alt="resumeBuilder" />
            <img src={tape3} alt="" />
            <Link to={`/projects/8`}>
              <button className="project-button">View Project</button>
            </Link>
          </motion.div>
        </div>
      </div>
      <div className="footer container">
        <Hr/>
        <div
          className="Text_bold text-center mb-3"
          style={{ fontSize: "50px" }}
        >
          😎QUICK LINK😎
        </div>
        <div className="quick-links Text_regular">
        <a href="https://github.com/codewithgaurave" target="_blank" rel="noopener noreferrer" className="quick-link">
          <img src={github} alt="GitHub" />
          <span>GitHub</span>
        </a>
        
        <a href="https://www.linkedin.com/in/gaurav-gupta-3a1256286/" target="_blank" rel="noopener noreferrer" className="quick-link">
          <img src={linkedin} alt="LinkedIn" />
          <span>LinkedIn</span>
        </a>
        
        <a href="https://www.canva.com/design/DAFx4aHvoZ8/5koIAjrQb26tJcoT_I4nTw/edit" target="_blank" rel="noopener noreferrer" className="quick-link">
          <img src={canva} alt="Canva" />
          <span>Canva</span>
        </a>
        
        <a href="https://www.figma.com/design/DEfC37rcIz02Bg0Vzp9dp6/Gaurav-Portfolio?node-id=0-1&node-type=canvas&t=qtetEJ4P7g9cboAR-0" target="_blank" rel="noopener noreferrer" className="quick-link">
          <img src={figma} alt="Figma" />
          <span>Figma</span>
        </a>
        
        {/* Add more links as needed */}
      </div>

      </div>
    </>
  );
};

export default Project;
